<template>
  <div class="landingSection2">
    <landing-container>
      <div class="landingSection2__benefits benefits">
        <div
          v-for="(benefit, index) in benefits"
          :key="index"
          class="benefits__item"
        >
          <gl-svg-icon :icon="benefit.logo" class="benefits__icon" width="48" />
          <p class="benefits__text">{{ benefit.text }}</p>
          <div />
        </div>
      </div>
    </landing-container>
  </div>
</template>

<script>
import GlSvgIcon from "@gl/GlSvgIcon";
import LandingContainer from "@/components/Landing/components/LandingContainer.vue";

export default {
  name: "LandingSection2",
  components: {
    GlSvgIcon,
    LandingContainer,
  },
  computed: {
    benefits() {
      return [
        {
          logo: "team",
          text: this.$t("A global team of leading blockchain developers"),
        },
        {
          logo: "blockchain",
          text: this.$t("5 years of developments"),
        },
        {
          logo: "global",
          text: this.$t("A developed global infrastructure"),
        },
        {
          logo: "scheme",
          text: this.$t("Unique technology"),
        },
        {
          logo: "patents",
          text: this.$t("2 patents"),
        },
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
.landingSection2 {
  padding: 0 0 32px;
  @media (min-width: $breakpoint-xl) {
    padding: 0 0 48px;
  }
}

.benefits {
  display: flex;
  max-width: 1169px;
  margin: -40px auto 0;
  flex-wrap: wrap;
  justify-content: center;

  @media (min-width: $breakpoint-xl) {
    margin: -108px auto 0;
  }

  &__item {
    width: 100%;
    padding: 16px;
    box-shadow: 0px -15px 50px rgba(0, 0, 0, 0.1);
    border-radius: 10px;
    background-color: #fff;
    display: flex;
    margin: 6px 0;
    align-items: center;

    @media (min-width: $breakpoint-md) {
      margin: 6px;
      flex-direction: column;
      align-items: center;
      padding: 32px 16px 16px;
      width: 221px;
    }
    @media (min-width: $breakpoint-xl) {
      padding: 48px 16px 32px;
    }
  }

  &__icon {
    margin-right: 16px;
    @media (min-width: $breakpoint-md) {
      margin-right: 0;
    }
  }

  &__text {
    @include text-subtitle-1;
    text-align: left;

    @media (min-width: $breakpoint-md) {
      margin-top: 16px;
      text-align: center;
    }
    @media (min-width: $breakpoint-xl) {
      margin-top: 32px;
    }
  }
}
</style>
